export interface ValidationOptions {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: RegExp;
}

export interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

export class Validator {
  static validateString(value: string, options: ValidationOptions): ValidationResult {
    const errors: string[] = [];
    const trimmedValue = value.trim();

    if (options.required && !trimmedValue) {
      errors.push('此字段为必填项');
      return { isValid: false, errors };
    }

    if (!trimmedValue && !options.required) {
      return { isValid: true, errors: [] };
    }

    if (options.minLength && trimmedValue.length < options.minLength) {
      errors.push(`最少需要 ${options.minLength} 个字符`);
    }

    if (options.maxLength && trimmedValue.length > options.maxLength) {
      errors.push(`最多允许 ${options.maxLength} 个字符`);
    }

    if (options.pattern && !options.pattern.test(trimmedValue)) {
      errors.push('格式不正确');
    }

    return { isValid: errors.length === 0, errors };
  }

  static validateEmail(email: string): ValidationResult {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return this.validateString(email, {
      required: true,
      pattern: emailPattern,
    });
  }
}

export function sanitizeFormData(data: unknown): unknown {
  return data;
}